import React, { Fragment, useLayoutEffect, useState } from "react";
import { useParams } from "react-router-dom";
import CustomersListComponent from "../component/app/insurance/CustomersList.component";
import BreadcrumbsComponent from "../component/base/Breadcrumbs.component";
import { useAppContext } from "../context/App.context";
import { Box } from "@mui/material";

const CustomersPage = () => {
  const app = useAppContext();
  const params = useParams();
  const [breadcrumb, setBreadcrumb] = useState({
    title: "",
    links: [
      { path: "/", name: "Home" },
      { path: null, name: "Insurance" },
    ],
  });

  useLayoutEffect(() => {
    let title = null;
    if (params.employeeId) {
      let employee = app.target.filter(
        (person) => person.employee_user_id === parseInt(params.employeeId)
      );
      title = employee[0].last_name;
    }
    setBreadcrumb({
      ...breadcrumb,
      title: `${title}'s Customers`,
    });
  }, []);
  return (
    <Fragment>
      <Box display={"flex"} mt={window.innerWidth <= 750 ? "36px" : "0px"}>
        <BreadcrumbsComponent {...breadcrumb} />
      </Box>
      <CustomersListComponent showBreadcrumbs={true} />
    </Fragment>
  );
};

export default CustomersPage;
